import 'react-app-polyfill/ie11';
import 'react-app-polyfill/stable';
import React from 'react';
import { createRoot } from 'react-dom/client';
import SharedFreeApp from './SharedFreeApp';
import App from './App';
import * as serviceWorker from './serviceWorker';

const sharedFreeElement = document.getElementById('shared-free');
if (sharedFreeElement) {
  const root = createRoot(sharedFreeElement);
  root.render(
    <React.StrictMode>
      <SharedFreeApp />
    </React.StrictMode>,
  );
}

const freeElement = document.getElementById('free');
if (freeElement) {
  const root = createRoot(freeElement);
  root.render(
    <React.StrictMode>
      <App />
    </React.StrictMode>,
  );
}

if (process.env.REACT_APP_ENABLE_MSW === 'true') {
  const { worker } = require('./mocks/browser');
  worker.start();
} else {
  // If you want your app to work offline and load faster, you can change
  // unregister() to register() below. Note this comes with some pitfalls.
  // Learn more about service workers: https://bit.ly/CRA-PWA
  serviceWorker.unregister();
}
